export default {
  surveyMetadata: {
    surveyClosed: 'Организатор закрыл доступ к опросу/тесту',
    canCloseTab: 'Вы уже прошли данный опрос/тест',
    canCloseTabFinished: 'Опрос/тест был завершен!',
    startSurvey: 'Начать',
    continueSurvey: 'Продолжить прохождение',
    timeLimit: 'Время прохождения теста:',
    finishPercentageHidden:
      'Результат и запись о тесте не будут отображены в личном кабинете, т.к. организатор предпочел скрыть результат',
    finishPercentageWithText:
      'Набрано баллов: {validAnswersScore} из {validVariantsScore} ({finishScore}%). {scoreText}',
    finishPercentage: 'Результат: {validAnswersCount} из {validVariantsCount} ({finishPercent}%)',
    title: 'Обнаружена существующая активная сессия',
    text: 'Вы уже начали тест в другой вкладке или на другом устройстве.\nЧтобы продолжить тест, вернитесь к уже открытой вкладке или нажмите кнопку "Продолжить здесь" - в этом случае все предыдущие сеансы теста будут закрыты. Тестирование будет продолжено с места остановки',
    continue: 'Продолжить здесь',
    finishSurvey: 'Завершить опрос',
    canCloseSurveyTab: 'Вы уже прошли данный опрос',
    canCloseSurveyTabFinished: 'Опрос был завершен!',
    feedbackClosed:
      'Вы не являетесь участником данного опроса, пожалуйста авторизуйтесь под другой учетной записью или обратитесь к организатору',
  },
};
